<template>
	<nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);">
		<ol class="breadcrumb border-bottom p-3">
			<li class="breadcrumb-item">
				<router-link :to="{path: '/'}" class="text-decoration-none">Главная</router-link>
			</li>
			<li class="breadcrumb-item">
				<router-link :to="{path: '/projects'}" class="text-decoration-none">Проекты</router-link>
			</li>
			<li class="breadcrumb-item active">Добавление нового проекта</li>
		</ol>
	</nav>
	<div class="container-fluid">
		<div class="mb-3">
			<h5>Добавление нового проекта</h5>
			<div class="text-muted">Создание нового проекта с созданием соответствующих папок и с указанием прав доступа пользователям и группам пользователей</div>
		</div>
		<div class="d-flex justify-content-center mt-5" v-if="init">
			<div class="spinner-border" style="width: 100px; height: 100px;"></div>
		</div>
		<form @submit.prevent="addProject" v-else>
			<div class="row">
				<div class="col-md-2 mb-3">
					<div class="card">
						<div class="card-header">Иконка</div>
						<div class="card-body text-center">
							<div v-if="previewIcon">
								<image-with-placeholder
									:src="previewIcon"
									class="mw-100 ratio ratio-1x1 rounded mb-2"
									height="100%"
									skeleton="shimmer"
									alt="icon"
								/>
							</div>
							<div>
								<img src="/assets/images/noimage1.png" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-5 mb-3">
					<div class="card">
						<div class="card-header">Параметры проекта</div>
						<div class="card-body">
							<div class="mb-3">
								<label for="inputName" class="form-label">Название *</label>
								<input ref="projectNameInput" class="form-control" type="text" id="inputName" v-model="project.name" :disabled="loading" required  />
							</div>
							<div class="mb-3">
								<label for="inputApiname" class="form-label">API Name *</label>
								<input class="form-control font-monospace" type="text" id="inputApiname" v-model="project.apiname" :disabled="loading" required />
							</div>
							<div class="mb-3">
								<label for="selectRepo" class="form-label">Репозиторий *</label>
								<select class="form-select" id="selectRepo" v-model="project.repo" :disabled="loading" required>
									<option :value="repo.repo" v-for="repo in repos">{{repo.name}}</option>
								</select>
							</div>
							<div class="mb-2 row">
								<div class="col-4">
									<label class="form-check-label" for="switchCreateReadme">Создать файл README.md?</label>
									<div class="form-check form-switch">
										<input class="form-check-input" type="checkbox" role="switch" id="switchCreateReadme" :disabled="loading" v-model="project.createReadme" />
									</div>
								</div>
								<div class="col-4">
									<label class="form-check-label" for="switchAutoMergeEnabled">Включить auto merge?</label>
									<div class="form-check form-switch">
										<input class="form-check-input" type="checkbox" role="switch" id="switchAutoMergeEnabled" :disabled="loading" v-model="project.autoMergeEnabled" />
									</div>
								</div>
								<div class="col-4">
									<label for="inputRequiredApprovals" class="form-label">Кол-во обязательных approvals *</label>
									<input class="form-control" type="number" id="inputRequiredApprovals" v-model.number="project.requiredApprovals" :disabled="loading" required />
								</div>
							</div>
							<div>
								<label for="inputIcon" class="form-label">Иконка</label>
								<input ref="fileInput" class="form-control" type="file" id="inputIcon" accept="image/*" @change="onFileChange" :disabled="loading" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-5 mb-3">
					<div class="card">
						<div class="card-header">Права доступа</div>
						<div class="card-body">
							<div class="input-group mb-3">
								<input type="text" class="form-control" placeholder="Поиск по пользователям и группам" :disabled="loading" v-model="search" />
								<button class="btn btn-outline-secondary d-flex align-items-center px-2" type="button" :disabled="loading" @click="search = ''" v-if="search">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
										<path d="M16.24,3.56L21.19,8.5C21.97,9.29 21.97,10.55 21.19,11.34L12,20.53C10.44,22.09 7.91,22.09 6.34,20.53L2.81,17C2.03,16.21 2.03,14.95 2.81,14.16L13.41,3.56C14.2,2.78 15.46,2.78 16.24,3.56M4.22,15.58L7.76,19.11C8.54,19.9 9.8,19.9 10.59,19.11L14.12,15.58L9.17,10.63L4.22,15.58Z" />
									</svg>
								</button>
							</div>
							<div>
								<div class="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										id="checkGroupAll"
										:checked="project.users.length === users.length"
										:disabled="loading"
										@change="toggleAllUsers"
									/>
									<label for="checkGroupAll" class="badge text-bg-primary font-monospace">@all</label>
								</div>
								<div class="ms-4">
									<div class="form-check" v-for="user in filteredUsers" :key="user.id">
										<input class="form-check-input" type="checkbox" :value="user.id" :id="'checkGroupAllUser' + user.id" :disabled="loading" v-model="project.users" />
										<label :for="'checkGroupAllUser' + user.id">
											<code>{{ user.login }}</code>
										</label>
									</div>
								</div>
							</div>
							<div v-for="group in filteredGroups" :key="group.id">
								<div class="form-check">
									<input class="form-check-input" type="checkbox" :value="group.id" :id="'checkGroup' + group.id" :disabled="loading" v-model="project.groups" />
									<label class="badge text-bg-dark font-monospace" :for="'checkGroup' + group.id">@{{ group.name }}</label>
								</div>
								<div class="ms-4">
									<div class="form-check" v-for="user in group.users" :key="user.id">
										<input class="form-check-input" type="checkbox" :value="user.id" :id="'checkGroup' + group.id + 'User' + user.id" :checked="hasCheckedGroup(group.id)" :disabled="loading" disabled />
										<label :for="'checkGroup' + group.id + 'User' + user.id">
											<code>{{ user.login }}</code>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card">
				<div class="card-body">
					<div class="d-grid gap-2 d-md-flex justify-content-md-end">
						<button
							type="submit"
							class="btn btn-primary d-flex align-items-center justify-content-center"
							:disabled="loading"
						>
							<span v-if="loading && loadingAdd" class="spinner-border spinner-border-sm me-2"></span>
							<svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
								<path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
							</svg>
							<span class="ms-2">{{ loading ? 'Создание...' : 'Добавить проект' }}</span>
						</button>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<style lang="scss"></style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';
import { useModal } from "vue-final-modal";

import ImageWithPlaceholder from '@/components/ImageWithPlaceholder.vue';
import BootstrapConfirmModal from "@/components/modals/BootstrapConfirmModal.vue";

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Добавление нового проекта | SKV'});
	},
	data: () => ({
		init: false,
		loading: false,
		loadingAdd: false,
		repos: [
			{
				repo: 'hg',
				name: 'Mercurial (HG)',
			},
			{
				repo: 'git',
				name: 'Git',
			},
		],
		users: [],
		groups: [],
		search: '',
		previewIcon: '',
		selectedFile: null,
		project: {
			name: '',
			apiname: '',
			repo: 'hg',
			requiredApprovals: 1,
			autoMergeEnabled: false,
			createReadme: true,
			users: [],
			groups: [],
		},
	}),
	computed: {
		filteredUsers(){
			const search = this.search.toLowerCase();
			return this.users.filter(user => user.login.toLowerCase().includes(search));
		},
		filteredGroups(){
			const search = this.search.toLowerCase();
			return this.groups.filter(group => group.name.toLowerCase().includes(search));
		},
	},
	methods: {
		hasCheckedGroup(groupId){
			return this.project.groups.includes(groupId);
		},
		toggleAllUsers(event){
			this.project.users = event.target.checked ? this.users.map(u => u.id) : [];
		},
		
		onFileChange(e) {
			const file = e.target.files[0];
			if (!file || !file.type.match('image.*')) {
				if (file) this.$toast.warning('Пожалуйста, выберите изображение');
				this.resetFile();
				return;
			}

			this.selectedFile = file; // Сохраняем "модель"
			if (this.previewIcon) URL.revokeObjectURL(this.previewIcon);
			this.previewIcon = URL.createObjectURL(file);
		},
		resetFile() {
			this.selectedFile = null;
			this.previewIcon = '';
			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = ''; // Очистка системного инпута
			}
		},
		async loadData() {
			this.loading = true;
			try {
				// Загружаем всех пользователей и все группы для выбора
				const [users, groups] = await Promise.all([
					this.appModel.doGetUsers({all: true}),
					this.appModel.doGetUserGroups({all: true}),
				]);
				this.users = users.list || [];
				this.groups = groups.list || [];
				this.project.users = this.users.map(u => u.id);
			} catch (e) {
				console.error(e);
			} finally {
				this.loading = false;
			}
		},
		
		async addProject() {
			this.loading = true;
			this.loadingAdd = true;
			try {
				const formData = new FormData();
				
				formData.append('name', this.project.name);
				formData.append('apiname', this.project.apiname);
				formData.append('repo', this.project.repo);
				formData.append('create_readme', this.project.createReadme ? 1 : 0);
				formData.append('auto_merge_enabled', this.project.autoMergeEnabled ? 1 : 0);
				formData.append('required_approvals', this.project.requiredApprovals);
				
				if (this.selectedFile) {
					formData.append('icon_file', this.selectedFile);
				}

				this.project.users?.forEach(id => {
					formData.append('users[]', id);
				});

				this.project.groups?.forEach(id => {
					formData.append('groups[]', id);
				});

				const result = await this.appModel.doAddProject(formData);
				if (result.success) {
					await this.appModel.refreshCounts();
					
					useModal({
						component: BootstrapConfirmModal,
						attrs: {
							title: "Проект успешно создан!",
							centered: true,
							confirmText: "В созданный проект",
							confirmColor: "link",
							cancelText: "В список проектов",
							onConfirm: () => {
								this.$router.push('/projects/' + result.data?.id);
							},
							onClose: () => {
								this.$router.push('/projects');
							},
						},
						slots: {
							default: 'Куда перейти?',
						},
					}).open();
				} else {
					this.$toast.error(result.message);
				}
			} finally {
				this.loading = false;
				this.loadingAdd = false;
			}
		},
	},
	async mounted() {
		this.init = true;
		await this.loadData();
		this.init = false;
		
		this.$nextTick(() => {
			this.$refs.projectNameInput?.focus();
		});
	},
	components: {
		ImageWithPlaceholder,
	},
};
</script>
